import React from "react";
import Box from "@mui/material/Box";
import Footer from "./components/Footer";
import Header from "./components/Header";
import SocialMediaSection from "./components/SocialMediaSection";
import HeroSection from "./components/Hero";
import StaggeredCards from "./components/StaggeredCards";
import Testimonials from "./components/Testimonials";

const HomeLayout = ({ toggleTheme, isDarkMode, handleLoginToggle }) => (
  <div style={{ position: "relative" }}>
  <div className="background-image">
  <video autoPlay loop muted className="background-video">
    <source
      src="s3://rocket-offer-images/background_video.mp4"
      type="video/mp4"
    />
    Your browser does not support the video tag.
  </video>
    <Header
      toggleTheme={toggleTheme}
      isDarkMode={isDarkMode}
      handleLoginToggle={handleLoginToggle}
    />
    <HeroSection />
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        maxWidth: { sm: "100%", md: "1700px" },
        margin: "0 auto",
      }}
    >
      <StaggeredCards />
    </Box>
    <Testimonials />
    <SocialMediaSection isDarkMode={isDarkMode} />
    <Footer />
  </div>
  </div>
);

export default HomeLayout;
